import {
  FileSelectorModal,
  FileSourceEnum,
  FileTypeEnum,
  FileUploaderItem,
  ImageCropperModalProps,
} from '@systemeio/file-manager'
import { FieldLabel, FieldLabelProps } from '@systemeio/ui'
import React, { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { FieldErrorAndDescription } from '../form/field-error-and-description'
import { ImageUploader, Props as ImageUploaderProps } from './image-uploader'

interface Props
  extends FieldLabelProps,
    Pick<ImageUploaderProps, 'isSuccess' | 'statusIcon' | 'disabled' | 'isPreFetching'>,
    Pick<ImageCropperModalProps, 'allowSwitchingCroppingShape' | 'isRounded'> {
  value?: { path: string } | null
  source: FileSourceEnum
  error?: string
  labelImageUploader?: React.ReactNode
  aspectRatio?: number
  previewClassName?: string
  dropZoneClassName?: string
  className?: string
  onSelect: ComponentProps<typeof FileSelectorModal>['onSelect']
  onRemove: () => void
}

export const ImageUploaderWithPreviewImage = ({
  value,
  source,
  error,
  label,
  labelImageUploader,
  required,
  aspectRatio = NaN,
  labelClassName,
  previewClassName,
  dropZoneClassName,
  isPreFetching,
  disabled,
  isSuccess,
  statusIcon,
  className,
  onSelect,
  onRemove,
  isRounded,
  allowSwitchingCroppingShape,
}: Props) => {
  return (
    <div className={twMerge('flex flex-col gap-1', className)}>
      <FieldLabel label={label} required={required} labelClassName={labelClassName} />

      {value && (
        <div className={twMerge('w-fit', statusIcon && 'relative')}>
          <FileUploaderItem
            file={{
              id: 0,
              path: value.path,
              size: 0,
              type: FileTypeEnum.Image,
              filename: '',
              thumbnail: value.path,
            }}
            showDeleteButton
            className={previewClassName}
            onDeleteFile={onRemove}
            disabled={isPreFetching || disabled}
          />

          {statusIcon && <div className="absolute left-2 top-2">{statusIcon}</div>}

          <FieldErrorAndDescription error={error} />
        </div>
      )}

      <ImageUploader
        showDropZone={!value}
        label={labelImageUploader}
        source={source}
        onSelect={onSelect}
        error={error}
        dropZoneClassName={dropZoneClassName}
        imageCropperModalProps={{
          allowSwitchingCroppingShape,
          isRounded,
          imageCropperProps: { aspectRatio },
        }}
        isPreFetching={isPreFetching}
        disabled={disabled}
        isSuccess={isSuccess}
        statusIcon={statusIcon}
      />
    </div>
  )
}
